export default "$(document).ready(function(){$(\"#elPassword\").passwordRequirements()});";